// import { IndexerSource } from '@prisma/client'

type Props = {
  source: any
  onSubmit: (sourceUpdated: any) => void
}

export const StepTwo: React.FC<Props> = ({ source, onSubmit }) => {
  return <>TODO</>
  // const configuration = source.configuration as DiscordConfigurationSetup

  // const { data: providerAccount } = Api.providerAccount.findUnique.useQuery({
  //   where: { id: source.providerAccountId },
  // })

  // const accountConfiguration =
  //   providerAccount?.configuration as DiscordConfigurationConnect

  // // const queryChannels = Api.discordV2.findManyChannels.useQuery(
  // //   {
  // //     botToken: configuration.botToken,
  // //     serverId: accountConfiguration?.serverId,
  // //   },
  // //   { initialData: [], enabled: !!accountConfiguration },
  // // )

  // const queryChannels = { data: [] }

  // const FormInstance = FormClient.useForModel({
  //   modelName: 'IndexerSource',
  //   keysToMerge: ['configuration'],
  //   onSuccess: onSubmit,
  // })

  // useEffect(() => {
  //   FormInstance.start({ where: { id: source.id } })
  // }, [])

  // const optionsChannels = useMemo(() => {
  //   const options = queryChannels.data.map(channel => ({
  //     label: channel.name,
  //     value: channel.id,
  //   }))

  //   return Toolbox.UtilityItems.sortByString(options, 'label')
  // }, [queryChannels.data])

  // return (
  //   <Flex vertical className="w-full">
  //     <FormInstance.FormView
  //       isModal={false}
  //       propsForm={{ buttonLabel: 'Next' }}
  //     >
  //       <Form.Item
  //         label="Channels"
  //         name="configuration.channelIds"
  //         rules={[
  //           { required: true, message: 'You must select at least one channel' },
  //         ]}
  //       >
  //         <Select
  //           mode="multiple"
  //           placeholder="Select channels"
  //           options={optionsChannels}
  //         />
  //       </Form.Item>
  //     </FormInstance.FormView>
  //   </Flex>
  // )
}
